<template>
  <highcharts
    ref="backRef"
    style="padding-top: 30px;"
    :options="chartOptions"
    class="chart"
    :constructor-type="'chart'"
  ></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../../router";
import { ProductModelDeliveredChart } from "../../../utils/ChartProps";
import { from, isUserLoggedIn, to } from "../../../utils/Utils";

export default {
  components: {
    router,
    highcharts: Chart
  },
  name: "ProductModelDelivered",
  props: ["dateFrom", "dateTo"],
  data: function() {
    return {
      from: from,
      to: to,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      valueQuantity: false,
      productModel: "",
      dateName: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {}
    };
  },
  watch: {
    dateFrom() {
      this.chartOptions = ProductModelDeliveredChart(
        router,
        this.from(this.dateFrom),
        this.to(this.dateTo),
        this.locationsIds
      );
    },
    dateTo() {
      this.chartOptions = ProductModelDeliveredChart(
        router,
        this.from(this.dateFrom),
        this.to(this.dateTo),
        this.locationsIds
      );
    },
    valueQuantity() {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http.get("api/charts/prodModelDelivered.php", { params }).then(
        res => {
          this.chartOptions.title.text = "Total units: " + res.data.totals;

          let tmp = res.data.upData;
          tmp.sort((a, b) => (parseFloat(a.y) > parseFloat(b.y) ? -1 : 1));

          let smp = res.data.dnData;
          smp.forEach(obj => {
            obj.data.sort((a, b) =>
              parseFloat(a.y) > parseFloat(b.y) ? -1 : 1
            );
            obj.data.splice(20, 5000);
          });

          let newArr = tmp.slice(0, 10);
          if (this.locParam == 0) {
            if (smp.length != 0) {
              this.chartOptions.series[0].data = smp[0].data;
            }
          } else {
            this.chartOptions.series[0].data = newArr;
            this.chartOptions.drilldown.series = smp;
          }

          this.chartOptions.chart.height = "45%";
          this.loadingData = false;
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Regional Analytics Active Backlog | " +
          (this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom) +
          this.locationName;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Regional Analytics Active Backlog | " + this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename:
          "RegionalBacklog-" +
          (this.from(this.dateFrom) ? this.from(this.dateFrom) : this.dateFrom)
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  mounted() {
    isUserLoggedIn(router);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("user");
    } else {
      this.locationsIds = this.idCity;
    }
    this.chartOptions = ProductModelDeliveredChart(
      router,
      this.from(this.dateFrom),
      this.to(this.dateTo),
      this.locationsIds
    );

    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.small {
  float: right !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
